import { Anchor, MantineFontSize, Text } from '@mantine/core';

import { IntlHelpers } from 'helpers/IntlHelpers';

import { useInbox } from 'hooks/use-inbox';
import { NotificationService } from 'services/NotificationService';

const DashboardUnread = ({ fz = 'lg' }: { fz?: MantineFontSize }) => {
    const { unreadCount } = useInbox();

    if (!unreadCount) {
        return null;
    }

    return (
        <Text fz={fz} c="gray.3">
            You have{' '}
            <Anchor
                component="button"
                inherit
                c="white"
                fw={600}
                underline="always"
                onClick={() => NotificationService.openInbox()}
            >
                {IntlHelpers.formatNumber(unreadCount)} unread {unreadCount === 1 ? 'notification' : 'notifications'}
            </Anchor>{' '}
            waiting for you.
        </Text>
    );
};

export { DashboardUnread };
